export enum TaskPriority {
  HIGH = 1,
  MEDIUM,
  LOW,
}

export const priority_list = [
  {
    id: "1",
    value: TaskPriority[TaskPriority.HIGH],
  },
  {
    id: "2",
    value: TaskPriority[TaskPriority.MEDIUM],
  },
  {
    id: "3",
    value: TaskPriority[TaskPriority.LOW],
  },
];
